export const environment = {
  production: false,
  useMocks: false,
  /** QA is not reachable from `ng serve` — recruit's QA CORS allows only *.geektrust.in
   *  origins, so this build must be served from that domain. */
  apiBaseUrl: 'https://qa-vetta.geektrust.in/recruitservice/api/v1',
  googleClientId: '960037786514-j3lj4e4hha2eodg3pkllfaaqq7fmgqog.apps.googleusercontent.com',
  allowedDomain: 'geektrust.in',
};
